/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Status_CanceledInputs */

const tr_geliver_status_canceled = /** @type {(inputs: Geliver_Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İptal edildi`)
};

const en_geliver_status_canceled = /** @type {(inputs: Geliver_Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelled`)
};

const de_geliver_status_canceled = /** @type {(inputs: Geliver_Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storniert`)
};

const ru_geliver_status_canceled = /** @type {(inputs: Geliver_Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отменено`)
};

/**
* | output |
* | --- |
* | "Cancelled" |
*
* @param {Geliver_Status_CanceledInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_status_canceled = /** @type {((inputs?: Geliver_Status_CanceledInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Status_CanceledInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_status_canceled(inputs)
	if (locale === "de") return de_geliver_status_canceled(inputs)
	if (locale === "ru") return ru_geliver_status_canceled(inputs)
	return tr_geliver_status_canceled(inputs)
});